import type { z } from 'zod';
import { MapPin } from 'lucide-react';

import type { NormalizedProvidedDetails, ReportSchema } from '@ballerine/common';

import { ReportWrapper } from '../../report-shared/components';
import { MerchantDetails } from '../components/MerchantDetails';

export const MerchantDetailsSection = ({
  merchantDetails,
  providedDetails,
  matchReason,
  googleMapsApiKey,
}: {
  merchantDetails: NonNullable<z.infer<typeof ReportSchema>['data']>['merchantDetails'] | null;
  providedDetails?: NormalizedProvidedDetails | null;
  matchReason?: string | null;
  googleMapsApiKey?: string | null;
}) => {
  return (
    <ReportWrapper
      Icon={MapPin}
      tooltip="Business registration and headquarters address information."
      showTooltip={false}
    >
      <MerchantDetails
        merchantDetails={merchantDetails}
        providedDetails={providedDetails}
        matchReason={matchReason}
        googleMapsApiKey={googleMapsApiKey || ''}
      />
    </ReportWrapper>
  );
};
